// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vu_a bhb_b bhb_ux"};